// extracted by mini-css-extract-plugin
module.exports = {"container":"GNmLy5F3Bfw6iEgiyrnIa","closeButton":"_33IMOUfTyK80MVyRKBSnEK"};